module.exports = __webpack_public_path__ + "img/edit-alt.65a4f42f.svg";